import React, { useState } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment';

export default function XDateRange({ onChange = () => { } }) {
    const [range, setRange] = useState({
        start: moment().subtract(7, 'days'),
        end: moment()
    });

    const handleCallback = (start, end) => {
        setRange({ start, end });
        // onChange(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'))
        console.log("Selected range:", start.format('YYYY-MM-DD'), "to", end.format('YYYY-MM-DD'));
    };
    React.useEffect(() => {
        onChange(range.start.format('YYYY-MM-DD'), range.end.format('YYYY-MM-DD'))
    }, [range])

    let inputStyle = {
        borderRadius: 4,
        border: '3px solid #eee',
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 8,
        paddingBottom: 8,
        fontSize: 12,
        background: '#ffff'

    }

    return (
        <div style={{ marginBottom: 10 }}>
            <DateRangePicker
                initialSettings={{
                     timePicker: true,
                    // timePicker24Hour: true,
                    // timePickerSeconds: true,
                    // showDropdowns: true,
                    startDate: range.start,
                    endDate: range.end,
                    // locale: {
                    //     format: 'YYYY-MM-DD HH:mm:ss',
                    // },
                    ranges: {
                        Today: [moment(), moment()],
                        Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                    }
                }}
                onCallback={handleCallback}
            >
                <div>
                    <div style={{ fontSize: 13 }}> Select range</div>
                    <div style={inputStyle}>
                        {range.start.format('yyyy-MM-DD HH:mm:ss')} - {range.end.format('yyyy-MM-DD HH:mm:ss')}
                    </div>
                </div>
               
            </DateRangePicker>
        </div>
    );
}
